/**
 * Shared access to the juice atlas frames for other drawers (Fall spawn bursts, score popups)
 * without importing Pixi: game-juice.js registers the source once the Pixi textures exist.
 * Until then (or on Canvas 2D) `getJuiceFrameTexture` returns null and callers fall back.
 */

var source = null;

/** @param {{ texture: (key: string) => object|null } | null} src */
export function setJuiceFrameSource(src) {
  source = src && typeof src.texture === "function" ? src : null;
}

/** Pixi texture of an atlas frame ("dot", "sparkle", "sparkle-ink", "star", …) or null. */
export function getJuiceFrameTexture(key) {
  return source ? source.texture(key) : null;
}
